import { createStore, c } from "redux";
import formReducer from "./form/formReducer";
import { composeWithDevTools } from "redux-devtools-extension";

const store = createStore(formReducer, composeWithDevTools());

export default store;